import Vue from 'vue'
//import Vuex
import Vuex from 'vuex'
Vue.use(Vuex)

import state from "./states.js"
import getters from "./getters.js"
import  mutations from "./mutations.js"
import actions from "./actions.js"

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})
export default store





// WEBPACK FOOTER //
// ./src/assets/vuex/store.js